import { Dispatch } from 'redux'

import { create, destroy, update } from 'redux/api/WidgetTagStatuses'
import { useThunkActions } from 'redux/actions/useThunkActions'

import {
  WidgetTagStatusPatchAttributes,
  WidgetTagStatusPostAttributes
} from 'types/GlobalWidgetTag'

import { toggleSnackbarOpen } from 'redux/actions/Snackbar'

import { SnackbarMessage } from 'types/GlobalSnackbar'

import * as actions from './actions'

function tryCreateWidgetTagStatus(
  body: WidgetTagStatusPostAttributes,
  widgetId: string,
  tagId: string
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.create())

    create(body)
      .then((response) => {
        dispatch(
          actions.createSuccess({
            statusItem: response.data.data,
            tagId,
            widgetId
          })
        )

        dispatch(toggleSnackbarOpen(SnackbarMessage.WidgetUpdated))
      })
      .catch(() => {
        dispatch(actions.createFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.WidgetUpdatedFailed))
      })
  }
}

function tryUpdateWidgetTagStatus(
  id: string,
  body: WidgetTagStatusPatchAttributes,
  widgetId: string,
  tagId: string
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.update())

    update(id, body)
      .then((response) => {
        dispatch(
          actions.updateSuccess({
            statusItem: response.data.data,
            tagId: tagId,
            widgetId: widgetId
          })
        )

        dispatch(toggleSnackbarOpen(SnackbarMessage.WidgetUpdated))
      })
      .catch(() => {
        dispatch(actions.updateFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.WidgetUpdatedFailed))
      })
  }
}

function tryDeleteWidgetTagStatus(id: string, widgetId: string, tagId: string) {
  return (dispatch: Dispatch) => {
    dispatch(actions.destroy())

    destroy(id)
      .then(() => {
        dispatch(
          actions.destroySuccess({
            id,
            widgetId,
            tagId
          })
        )

        dispatch(toggleSnackbarOpen(SnackbarMessage.WidgetUpdated))
      })
      .catch(() => {
        dispatch(actions.destroyFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.WidgetUpdatedFailed))
      })
  }
}

export const useWidgetTagStatusActions = () => {
  return {
    tryCreateWidgetTagStatus: useThunkActions(tryCreateWidgetTagStatus),
    tryUpdateWidgetTagStatus: useThunkActions(tryUpdateWidgetTagStatus),
    tryDeleteWidgetTagStatus: useThunkActions(tryDeleteWidgetTagStatus)
  }
}
